export default __webpack_public_path__ + "static/media/hht2_ep06_timeline_04.6e9fdebe.png";